import { Injectable } from "@angular/core";

declare function unescape(s:string): string;
declare function escape(s:string): string;

interface ResizeImageOptions {
  maxSize: number;
  file: File;
}

@Injectable()
export class ImageResizer {

  constructor() {
    //
  }

  public process(settings: ResizeImageOptions): Promise<any> {
    const { maxSize, file } = settings;

    const reader = new FileReader();
    const image = new Image();
    const canvas = document.createElement("canvas");

    const dataURIToBlob = (dataURI: string) => {
      const bytes =
        dataURI.split(",")[0].indexOf("base64") >= 0
          ? atob(dataURI.split(",")[1])
          : unescape(dataURI.split(",")[1]);
      const mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
      const max = bytes.length;
      const ia = new Uint8Array(max);
      for (let i = 0; i < max; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ia], { type: mime });
    };

    const resize = () => {
      let { width, height } = image;
      if (width > height) {
        height *= maxSize / width;
        width = maxSize;
      } else {
        if (height > maxSize) {
          width *= maxSize / height;
          height = maxSize;
        }
      }

      canvas.width = width;
      canvas.height = height;
      canvas.getContext("2d").drawImage(image, 0, 0, width, height);
      let dataUrl = canvas.toDataURL("image/jpeg");
      return dataURIToBlob(dataUrl);
    };

    return new Promise((resolve, reject) => {
      if (!file.type.match(/image.*/)) {
        reject(new Error("Not an image"));
        return;
      }

      reader.onload = (event: any) => {
        image.onload = () => resolve(resize());
        image.src = event.target.result;
      };
      reader.readAsDataURL(file);
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/imageResizer.service.ts